import React, { useState } from 'react';
import './Sidebar.css';
import { useReservations, useReservationsFreeTable, useUnconfirmedReservationsFreeTable } from '../../api/reservations';
import ReservationDetailsModal from '../../Screens/ReservationDetails/ReservationDetails';
import FreeTableReservations from '../FreeTableReservations/FreeTableReservations';

const Sidebar = ({
  onReservationClick,
  tables,
  selectedDate,
  setSelectedDate,
  tempSelectedTables,
  tempPartySize,
}) => {
  const { data: reservations = [], isLoading, error } = useReservations();
  const { data: reservationsFreeTable = [], isLoading: reservationsFreeTableLoading, error: reservationsFreeTableError } = useReservationsFreeTable();
  const { data: unconfirmedReservations = [], isLoading: unconfirmedReservationsLoading, error: unconfirmedReservationsError } = useUnconfirmedReservationsFreeTable();
  const [selectedReservationId, setSelectedReservationId] = useState(null);
  const [selectedReservationGuestId, setSelectedReservationGuestId] = useState(null);

  if (isLoading || reservationsFreeTableLoading || unconfirmedReservationsLoading) {
    return <div className="sidebar">Loading reservations...</div>;
  }
  if (error || reservationsFreeTableError || unconfirmedReservationsError) {
    return <div className="sidebar">Failed to load reservations.</div>;
  }

  const uniqueDates = [...new Set(reservations.map(res => res.time.split(' ')[0]))].sort();
  const filteredReservations = reservations.filter(res => !selectedDate || res.time.startsWith(selectedDate));
  const isMobile = window.innerWidth <= 768;

  const hasTableConflict = (reservation) => {
    const reservationTime = new Date(reservation.time).getTime();
    return filteredReservations.some(otherRes => {
      if (otherRes.id === reservation.id) return false;
      const otherTime = new Date(otherRes.time).getTime();
      const timeDiff = Math.abs(reservationTime - otherTime);
      const withinOneHour = timeDiff <= 60 * 60 * 1000;
      const sharesTable = reservation.tableIds.some(tableId => otherRes.tableIds.includes(tableId));
      return withinOneHour && sharesTable;
    });
  };

  const handleConfirm = (reservationId) => {
    console.log(`Confirm reservation ${reservationId}`);
    // Add actual confirm logic here
  };

  const handleDeny = (reservationId) => {
    console.log(`Deny reservation ${reservationId}`);
    // Add actual deny logic here
  };

  return (
    <div
      className="sidebar"
      style={{
        backgroundColor: 'white',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      }}
    >
      {/* Regular Reservations Section */}
       <div
        style={{
          padding: '10px',
          borderBottom: '1px solid #3fb488',
        }}
      >
        <div
          style={{
            fontWeight: 'bold',
            fontSize: '16px',
            marginBottom: '12px',
          }}
        >
          Резервации
        </div>
      </div>
      <div
        style={{
          flex: 1,
          overflowY: 'auto',
          padding: '10px',
        }}
      >
       
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '70px 40px 1fr 40px 40px 60px',
            fontWeight: 'bold',
            fontSize: '14px',
            marginBottom: '8px',
            gap: '8px',
            alignItems: 'center',
            borderBottom: '1px solid #3fb488',
          }}
        >
          <div>Време</div>
          <div></div>
          <div>Име</div>
          <div>Луѓе</div>
          <div></div>
          <div>Маса</div>
        </div>
        {filteredReservations.map(reservation => {
          const assignedTables = tables.filter(table => reservation.tableIds.includes(table.id));
          const totalSeatsAssigned = assignedTables.reduce((sum, table) => sum + table.seats, 0);
          const totalSeatsUsed = Math.min(reservation.partySize, totalSeatsAssigned);
          const date = new Date(reservation.time);
          const timeString = date.toLocaleTimeString([], {
            hour: '2-digit',
            minute: '2-digit',
            hour12: false,
          });
          const tempSeats = tempSelectedTables.length > 0 && reservation.id === tempPartySize?.reservationId
            ? tables
                .filter(table => tempSelectedTables.includes(table.id))
                .reduce((sum, table) => sum + table.seats, 0)
            : 0;

          const isConflicted = hasTableConflict(reservation);

          const statusDisplay = {
            pending: '"Во чекање"',
            seated: 'Седната',
            finalized: 'Финализирана',
            canceled: 'Откажана',
            noshow: 'Неостварена',
            CONFIRMED:"Во чекање",
            DECLINED:"Одбиена",
            PENDING:"Чека потврда од гостин"


          };

          return (
            <div
              key={reservation.id}
              style={{
                display: 'grid',
                gridTemplateColumns: '70px 40px 1fr 40px 40px 60px',
                alignItems: 'center',
                padding: '8px',
                marginBottom: '8px',
                borderRadius: '8px',
                backgroundColor: 'white',
                boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
                cursor: 'pointer',
                fontSize: '14px',
                border: reservation.id === tempPartySize?.reservationId ? '2px solid #0288d1' : '1px solid #e0e0e0',
                transition: 'box-shadow 0.2s',
              }}
              onClick={() => {
                setSelectedReservationId(reservation.id);
                setSelectedReservationGuestId(reservation.guest_id);
              }}
              onMouseEnter={(e) => (e.currentTarget.style.boxShadow = '0 2px 6px rgba(0, 0, 0, 0.15)')}
              onMouseLeave={(e) => (e.currentTarget.style.boxShadow = '0 1px 3px rgba(0, 0, 0, 0.1)')}
            >
              <div style={{ fontWeight: 'bold' }}>{timeString}</div>
              <div
                style={{
                  width: '24px',
                  height: '24px',
                  borderRadius: '50%',
                  backgroundColor: '#e0f7fa',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '12px',
                  color: '#0288d1',
                }}
              >
                {(reservation.name || 'Непознато').charAt(0).toUpperCase()}
              </div>
              <div>
                <strong>{reservation.name || 'Непознато'}</strong>
                

              </div>
              
              <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                {reservation.partySize}
              </div>
              <div> {reservation.discount && <div style={{background:"#3fb488", color:"white", padding:5, width:25, textAlign:"center", borderRadius:10,}}>-{reservation.discount}%</div>}</div>
              {reservation.status !== 'canceled' && reservation.status !== 'DECLINED' && reservation.status !== 'PENDING'&& (
  <div
    style={{
      backgroundColor: '#e0e0e0',
      padding: '4px 8px',
      borderRadius: '4px',
      textAlign: 'center',
      border: isConflicted ? '2px solid red' : 'none',
    }}
    onClick={(e) => {
      if (!isMobile) {
        e.stopPropagation();
        onReservationClick(reservation.id);
      }
    }}
  >
    {assignedTables.length > 0
      ? assignedTables.map(t => t.display_number || t.display_number).join(', ')
      : (tempSeats > 0 ? `На чекање (${tempSelectedTables.join(', ')})` : 'Нема')}
  </div>
)}
              {assignedTables.length > 0 && (
                <div style={{ gridColumn: '1 / -1', marginTop: '4px' }}>
                  <div
                    style={{
                      width: '100%',
                      height: '4px',
                      backgroundColor: '#e0e0e0',
                      borderRadius: '2px',
                    }}
                  >
                    <div
                      style={{
                        width: `${(totalSeatsUsed / reservation.partySize) * 100}%`,
                        height: '100%',
                        backgroundColor: totalSeatsUsed >= reservation.partySize ? '#4CAF50' : '#FFC107',
                        borderRadius: '2px',
                      }}
                    />
                  </div>
                </div>
              )}
              <div style={{ gridColumn: '1 / -1', fontSize: '12px', color: '#666' }}>
                {totalSeatsUsed}/{reservation.partySize}
                {tempSeats > 0 && <span style={{ color: '#0288d1' }}> + {tempSeats}</span>}
                {reservation.status !== 'pending'&&reservation.status!=="CONFIRMED" && (
                  <span
                    style={{
                      marginLeft: '8px',
                      color: reservation.status === 'seated' ? '#4CAF50' : reservation.status === 'finalized' ? '#0288d1' : '#e74c3c',
                    }}
                  >
                    • {statusDisplay[reservation.status] || statusDisplay.pending}
                  </span>
                )}
              </div>
            </div>
          );
        })}
      </div>

      {/* Free Table and Unconfirmed Reservations Section */}
      <FreeTableReservations
        reservationsFreeTable={reservationsFreeTable}
        unconfirmedReservations={unconfirmedReservations}
        tempPartySize={tempPartySize}
        handleConfirm={handleConfirm}
        handleDeny={handleDeny}
        setSelectedReservationId={setSelectedReservationId}
      />

      {selectedReservationId && (
        <ReservationDetailsModal
          reservationId={selectedReservationId}
          guestID={selectedReservationGuestId}
          tables={tables}
          onClose={() => setSelectedReservationId(null)}
        />
      )}
    </div>
  );
};

export default Sidebar;